const routes = [
    {
        path: "/classrooms",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'classroom_index'
        }
    }
];

export default routes;
